import type { RejectIncomingCallEventPublisher } from '@usecases/reject-incoming-call.usecase';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import { Logger } from '@main/utils/logger';

export class RejectIncomingCallPublisher
  implements RejectIncomingCallEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publish(callId: string): Promise<void> {
    const busIframe = await BusIframe.getIframe();

    const busEvent: BusEvent = {
      type: 'DIALER.REJECT',
    };

    this.logger.info('Publisher: rejecting incoming call', {
      action: 'RejectIncomingCall',
      callId,
    });

    // SCV's callended event does not fire for rejected (unanswered) calls.
    // Post VOICE_CALL_ENDED explicitly so the LWC utility component can react.
    if (window.parent) {
      window.parent.postMessage(
        { type: 'SCV.VOICE_CALL_ENDED', data: { callId } },
        '*',
      );
    }

    return BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: busEvent,
    });
  }
}
